module.exports = __webpack_public_path__ + "assets/img/prize-ticket.b86f89aa.png";